import React from 'react'
import { useSelector } from 'react-redux';
import { IncentiveRadioSelector } from './IncentiveRadioSelector';
import { openComponent, updateIncentiveValue } from '../../../../stateManagement/actions/incentiveActions';
import { IncentiveHeader } from '../incentiveHeader/IncentiveHeader';

export const IncentiveRadio = (props: { stateName: string, options:any[]}) => {

    const radioSelected = useSelector((state: any) => state?.manageIncentive?.data[props.stateName]);
    const storedDates = useSelector((state: any) => state?.manageIncentive?.data["storedDates"]);
    
    const handleRadioChange = (value: string) => {
        if(!radioSelected?.value && value && radioSelected.childState){
            openComponent(radioSelected.childState);
        }
        updateIncentiveValue(value, props.stateName);
        updateIncentiveValue(null ,"storedDates");
        storedDates.isValid = false;
        if(value){
            radioSelected.isValid = true;
        }
    };
    return (
            <IncentiveHeader heading={radioSelected?.label} open={radioSelected?.isOpen}>
                <IncentiveRadioSelector
                options={props.options}
                handleChange={handleRadioChange}
                selectedValue={radioSelected?.value}
                />
            </IncentiveHeader>
    );
}
